export * from "./types";
export * from "./shared";
export * from "./catalog";
export * from "./contrast";
export * from "./recipes";
export * from "./presets";

import type { TemplateFn } from "./types";

// Cache for promises, not resolved functions
const templatePromises = new Map<string, Promise<TemplateFn>>();

export function loadTemplate(key: string): Promise<TemplateFn> {
  const normalizedKey = key === "standard" ? "classic-academic" : key;

  if (templatePromises.has(normalizedKey)) {
    return templatePromises.get(normalizedKey)!;
  }

  let loader: Promise<TemplateFn>;
  switch (normalizedKey) {
    case "modern-bento":
      loader = import("./themes/modern-bento").then((m) => m.renderModernBento);
      break;
    case "modern-executive":
      loader = import("./themes/modern-executive").then((m) => m.renderModernExecutive);
      break;
    case "minimalist-scholar":
      loader = import("./themes/minimalist-scholar").then((m) => m.renderMinimalistScholar);
      break;
    case "grid-showcase":
      loader = import("./themes/grid-showcase").then((m) => m.renderGridShowcase);
      break;
    case "classic-academic":
    default:
      loader = import("./themes/classic-academic").then((m) => m.renderClassicAcademic);
      break;
  }

  templatePromises.set(normalizedKey, loader);
  return loader;
}

export function getAvailableTemplates(): string[] {
  return ["classic-academic", "standard", "modern-executive", "minimalist-scholar", "grid-showcase", "modern-bento"];
}
